/**
 * @class
 * @memberOf P3.tracking
 */
export default class TrackingData {
    constructor() {
    }
}